/**
 * Shared employee category / employment-type reference data.
 * Both the Categories management page and EmployeeForm import from here
 * so the initial seed data is always consistent.
 */

export const INITIAL_CATEGORIES = [
  { id: 1, name: "Senior Staff",    description: "Employees with 5+ years of service", employmentType: "Permanent" },
  { id: 2, name: "Junior Staff",    description: "Employees with less than 5 years",   employmentType: "Permanent" },
  { id: 3, name: "Temporary Staff", description: "Short-term contract employees",       employmentType: "Temporary" },
  { id: 4, name: "Intern",          description: "Internship / trainee positions",      employmentType: "Intern"    },
  { id: 5, name: "Probation",       description: "Employees under probation period",    employmentType: "Probation" },
];

export const EMPLOYMENT_TYPES = ["Permanent", "Temporary", "Contract", "Intern", "Probation"];
